import { summaryHasDetails } from '@src/features/transactables/summary/core/summaryHasDetails';
import { getCartDiscountCents, isCartCouponApplied, type Cart } from '@src/domains/cart';
import { shouldShowServiceFee } from '@src/domains/service-fees';

export const cartSummaryHasDetails = (cart: Cart | null | undefined, serviceFeeFeatureEnabled: boolean): boolean =>
  summaryHasDetails({
    discountCents: getCartDiscountCents(cart),
    isCouponApplied: isCartCouponApplied(cart),
    showServiceFee: shouldShowServiceFee(
      cart?.costPreview?.serviceFeeCurrencyInfo?.amountCents,
      serviceFeeFeatureEnabled,
    ),
  });
